import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import BlogSidebar from '../../components/blog-sidebar'
import BlogComments from '../../components/blog-comments'
import BlogAbout from '../../components/blog-about'
import Footer from '../../components/footer'

import bg from '../../assets/images/bg.jpg'

export default function BlogBlockquotePost() {
  return (
    <>
     <Navbar/> 

      <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Blockquote Post</h4>
                            <p className="text-muted mb-0">We present and write attractive blog posts with Sidebar</p>                                        
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Blog</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">Blockquote-post</span> 
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <ShapeTwo/>

      <section className="section">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 col-md-6">
                    <div className="card blog blog-primary text-center border-0">
                        <div className="bg-soft-primary p-4 rounded shadow">
                            <div className="position-relative">
                                <div className="blog-line"></div>
                                <span className="blog-icon mx-auto rounded-circle bg-white"><i className="mdi mdi-24px mdi-format-quote-open"></i></span>
                            </div>

                            <div className="py-4 px-lg-4 my-2">
                                <p className="text-dark fst-italic h5 mb-0">“ I'm selfish, impatient and a little insecure. I make mistakes, I am out of control and at times hard to handle. But if you can't handle me at my worst, then you sure as hell don't deserve me at my best. ”</p>
                                <h6 className="mb-0 mt-3"> - Marilyn Monroe</h6>
                            </div>

                            <div className="position-relative">
                                <div className="blog-line"></div>
                                <span className="blog-icon mx-auto rounded-pill bg-white"><i className="mdi mdi-24px mdi-format-quote-close"></i></span>
                            </div>
                        </div>
                    </div>

                    <div className="card blog blog-primary border-0 rounded-0">
                        <BlogAbout/>
                    </div>
                    <BlogComments/>
                </div>
                <div className="col-lg-4 col-md-6">
                    <BlogSidebar/>
                </div>
            </div>
        </div>
      </section>
      <Shape/>
      <Footer/>
      
    </>
  )
}
